/**
* @Author: zachalam
* @Date:   2017-02-13T15:41:43-08:00
* @Email:  zach@reflexmedia.com
* @Last modified by:   zachalam
* @Last modified time: 2017-02-13T15:41:43-08:00
*/

import React, { Component } from 'react';
import JoinS2 from '../components/pages/Join/JoinS2';
import { connect } from 'react-redux';
import { createProfile, refreshProfile } from '../actions/profileActions';
import { setLoading } from '../actions/commonActions';
import { browserHistory } from 'react-router';

class JoinS2Container extends Component {
  componentWillMount() {
    this.props.refreshProfile();
  }

  render() {
    return (
      <JoinS2 {...this.props} />
    );
  }
}

const mapStateToProps = (state) => {
  return {
    email: state.profile.email
  }
}

const mapDispatchToProps = (dispatch,ownProps) => {
  return {
    refreshProfile: () => {
      dispatch(refreshProfile())
    },
    registerProfile: (formData) => {
      // call api to register profile
      dispatch(setLoading());
      dispatch(createProfile(formData))
      .then(() => {
        // continue user to edit their profile.
        // delay loader by 0.5 second, for UI.
        window.setTimeout(() => {
          dispatch(setLoading());
          browserHistory.push("/profile/edit");
        },500)

      })
    }
  }
}

export default connect(mapStateToProps,mapDispatchToProps)(JoinS2Container);



// WEBPACK FOOTER //
// ./src/containers/JoinS2Container.jsx